import client from "./client";

export const listAudit = async (params) => (await client.get("/platform/audit", { params })).data;

export const auditCsvUrl = (params) => {
  const query = new URLSearchParams(Object.entries(params).filter(([, v]) => v));
  return `${process.env.REACT_APP_BACKEND_URL}/api/platform/audit/export?${query}`;
};

export const setStaffPerms = async (id, perms) =>
  (await client.put(`/platform/staff/${id}/perms`, { perms })).data;
